module.exports = __webpack_public_path__ + "img/logo2.8284d65.png";